import { DndProvider, createDndContext } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import React, { useRef } from 'react';

const RNDContext = createDndContext(HTML5Backend);

function useDNDProviderElement(props: any) {
    const manager = useRef(RNDContext);

    if (!props.children) return null;

    return (
        <DndProvider
            backend={HTML5Backend}
            manager={manager.current.dragDropManager}
            options={{ enableMouseEvents: true }}
        >
            {props.children}
        </DndProvider>
    );
}

export default function DragAndDrop(props: any) {
    const DNDElement = useDNDProviderElement(props);
    return <React.Fragment>{DNDElement}</React.Fragment>;
}
